import { Modal as ModalRac, ModalOverlay, Dialog, type ModalOverlayProps, Heading } from "react-aria-components";
import { css } from "../../../../styled-system/css";
import type { SystemStyleObject } from "../../../../styled-system/types";
import { FaXmark } from "react-icons/fa6";
import { Button } from "./Button";
import type { ComponentProps, ReactNode } from "react";

const overlayStyles = css({
  display: "flex",
  zIndex: "modal",
  position: "fixed",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  justifyContent: "center",
  alignItems: "center",
  backgroundColor: "black/50",
});

const dialogStyles = css.raw({
  display: "flex",
  position: "relative",
  gap: "medium",
  flexDirection: "column",
  outline: "none",
  maxWidth: "75vw",
  maxHeight: "85vh",
  marginX: "auto",
  paddingY: "large",
  fontSize: "medium",
  backgroundColor: "white",
  boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
  overflow: "hidden",
});

export interface Props extends Omit<ModalOverlayProps, "children" | "className"> {
  css?: SystemStyleObject;
  children?: ComponentProps<typeof Dialog>["children"];
  title?: ReactNode;
}

export const Modal = ({ children, css: cssProp, title, ...props }: Props) => {
  return (
    <ModalOverlay className={overlayStyles} {...props}>
      <ModalRac>
        <Dialog className={css(dialogStyles, cssProp)}>
          {(opts) => {
            return (
              <>
                <Button
                  variant={"contentOnly"}
                  css={{
                    position: "absolute",
                    top: "medium",
                    right: "medium",
                    color: { base: "lightgrey", _hover: "grey" },
                    fontSize: "xx-large",
                    lineHeight: "1",
                    _hover: { backgroundColor: "transparent" },
                  }}
                  onPress={() => opts.close()}
                >
                  <FaXmark />
                </Button>
                {title && (
                  <Heading
                    slot={"title"}
                    className={css({
                      margin: "0",

                      marginRight: "large",
                      paddingX: "large",
                      fontSize: "xxlarge",
                      fontWeight: "700",
                      textAlign: "center",
                    })}
                  >
                    {title}
                  </Heading>
                )}
                {typeof children === "function" ? children(opts) : children}
              </>
            );
          }}
        </Dialog>
      </ModalRac>
    </ModalOverlay>
  );
};
